import { Radio as MUIRadio, RadioProps } from '@mui/material';
import { BlankCircle, FilledCircle } from '../icons';
import { memo } from 'react';

const Radio = memo((props: RadioProps) => {
	const { color, ...rest } = props;

	return (
		<>
			<MUIRadio
				disableRipple
				sx={{
					'&, &.Mui-checked': {
						color: color || 'theme.primary.700'
					}
				}}
				icon={<BlankCircle color='theme.secondary.300' fontSize='large'/>}
				checkedIcon={<FilledCircle fontSize='large'/>}
				{...rest}
			/>
		</>
	);
});

export { Radio };
export default Radio;
